export default __webpack_public_path__ + "static/media/chevron-prev.99b395b2.svg";